/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Api_V3_KeyInputs */

const en_admin_settings_fields_wechat_api_v3_key = /** @type {(inputs: Admin_Settings_Fields_Wechat_Api_V3_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIv3 Key`)
};

const zh_admin_settings_fields_wechat_api_v3_key = /** @type {(inputs: Admin_Settings_Fields_Wechat_Api_V3_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIv3 密钥`)
};

/**
* | output |
* | --- |
* | "APIv3 Key" |
*
* @param {Admin_Settings_Fields_Wechat_Api_V3_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_api_v3_key = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Api_V3_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Api_V3_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_api_v3_key(inputs)
	return zh_admin_settings_fields_wechat_api_v3_key(inputs)
});
export { admin_settings_fields_wechat_api_v3_key as "admin.settings.fields.wechat_api_v3_key" }